<template>
  <div>
    <!-- Search input -->
    <div class="row no-gutters">
      <div class="search-bar col-6 p-0">
        <input
          class="form-control-lg search py-0"
          name="searchKeyword"
          v-model="searchKeyword"
          type="text"
          :placeholder="$tc(placeholder)"
          autocomplete="off"
        />
      </div>
    </div>

    <!-- Total results label -->
    <div class="results-count pt-4 pl-3" v-show="total">
      <span id="resultsCountNumber">{{ total }}</span>
      <span id="resultsText">
        {{ $tc('nav.settings.nav.user.results', total) }}</span
      >
    </div>

    <!-- Users list -->
    <user-list-list-item
      :results="users"
      :attributes="attributes"
      @delete="deleteUser"
    >
    </user-list-list-item>

    <!-- Pagination -->
    <core-pagination
      :page.sync="page"
      :pages.sync="pages"
      :pageSize.sync="pageSize"
      @update="getUsers"
    ></core-pagination>
  </div>
</template>

<script>
import User from '@/services/hatsApi/User'

export default {
  data () {
    return {
      placeholder: 'nav.settings.nav.user.search-placeholder',
      attributes: ['firstName', 'email', 'id'],
      users: [],
      total: 0,
      searchKeyword: '',
      page: 1,
      pages: 1,
      pageSize: 10
    }
  },
  created () {
    this.debouncedSearch = this.$_.debounce(this.getUsers, 500)
    this.getUsers()
  },
  watch: {
    searchKeyword: function () {
      this.debouncedSearch()
    }
  },
  methods: {
    async getUsers () {
      try {
        let filters = [
          {
            property: 'query',
            value: this.searchKeyword
          }
        ]
        const { data } = await User.getUsers(filters, this.pageSize, this.page)
        if (this.page !== 1 && data.data.length === 0) {
          this.page = 1
          this.getUsers()
        } else {
          this.users = data.data
          this.total = data.total
          this.page = data.page
          this.pages = data.pages
        }
      } catch (e) {}
    },
    /**
     * Delete user by id
     * @param {string | int} id
     * @returns {void}
     */
    async deleteUser (id) {
      try {
        await User.deleteUser(id)
        this.getUsers()
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Index.vue